// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_UploadReceiptInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payroll/upload_receipt
 *
 * Validates input for uploading a payment receipt.
 * Multipart form: execution_id (POST field) + receipt (file).
 */
import { registerContract } from './validate'

export interface Payroll_UploadReceiptInput {
execution_id: number
_files: unknown[]
}

registerContract('Payroll_UploadReceiptInput', {
  execution_id: { type: 'number',  required: true },
  _files:       { type: 'array',   required: true },
})
